import { render, staticRenderFns } from "./ParticipateAwardConfirmationModal.vue?vue&type=template&id=5dd83bca&scoped=true"
import script from "./ParticipateAwardConfirmationModal.vue?vue&type=script&lang=js"
export * from "./ParticipateAwardConfirmationModal.vue?vue&type=script&lang=js"
import style0 from "./ParticipateAwardConfirmationModal.vue?vue&type=style&index=0&id=5dd83bca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dd83bca",
  null
  
)

export default component.exports